export default __webpack_public_path__ + "static/media/soch.d3dcb279.png";